export default __webpack_public_path__ + "static/media/Vambraces of the Painlegion.e506353f.jpg";